// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1AC8t","additionalInfo":"AgreementModal_additionalInfo__2yF0E"};